import { Component, OnInit } from '@angular/core';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { OrderService } from '../../Services/order.service';
import { ViewEncapsulation } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { OrderConsts } from '../../constants';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
    selector: 'app-order-detail',
    templateUrl: './order-detail.component.html',
    styleUrls: ['./order-detail.component.scss', '../../../cart/cart.component.scss', '../../../product/product.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OrderDetailComponent implements OnInit {
  orderId: any;
  products = [];
  orderDetails = {};
  componentLoaded = false;
  invoicePdfPath = environment.magentoS3Path + '/' + environment.orderInvoiceFolder
  filters = [{id:1, name:'Category: Ascending', sort:'category_name', sortOrder:'asc'},
  {id:2, name:'Category: Descending', sort:'category_name', sortOrder:'desc'},
  {id:3, name:'RSP: High to low', sort:'rsp', sortOrder:'desc'},
  {id:4, name:'RSP: Low to high', sort:'rsp', sortOrder:'asc'},
  {id:5, name:'QTY: High to low', sort:'qty', sortOrder:'desc'},
  {id:6, name:'QTY: Low to high', sort:'qty', sortOrder:'asc'},]
  selectedSort:any = null;
  sort = '';
  sortOrder = '';
  orderStatueClasses = {'Order placed':'order_placed','Awaiting Pick':'order_placed','In Pick':'in_pick','Partial Delivered':'partial_delivered','Open':'delivered', 'Dispatched':'dispatched', 'Cancelled':'order_incomplete','Not Delivered':'order_incomplete','Unfulfilled':'order_incomplete','Order Cancelled':'order_incomplete' ,'Order Incomplete':'order_incomplete', 'Order Confirmed': 'delivered', 'Partial Refund':'partial', 'Refund':'refund'}
  isFirstOpen = false;
  isFirstOpen1 = true;
  global_data : any = {};
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  constructor(private activatedRoute: ActivatedRoute, private statePersist: StatePersistService,
    private orderService: OrderService,private router: Router, private titleService: Title,private alertService: AlertService
    ) { 
      const body = document.getElementsByTagName('body')[0];
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(res => {
        if (this.router.url == "/order/detail/:orderid") {
          body.classList.add('adjust-logo');
        }
        else {
          body.classList.remove('adjust-logo');
        }
      });
    }

  ngOnInit(): void {
    this.statePersist.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })
    this.titleService.setTitle(OrderConsts.ORDER_DETAIL_PAGE_TITLE);
    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.removeLocalStorage('product_data')
    this.orderId = this.activatedRoute.snapshot.paramMap.get('orderid')
    this.orderDetail()
  }

  resetSort(){
    this.sort = '';
    this.sortOrder = '';
    this.selectedSort = null;
    this.orderDetail()
  }

  convertToInt(value: string): number {
    return parseInt(value, 10); // Base 10 for decimal numbers
  }

  productSort(){
    if(this.selectedSort == ''){
      this.selectedSort = 1
    }
    this.sort = this.filters[this.selectedSort-1]['sort']
    this.sortOrder = this.filters[this.selectedSort-1]['sortOrder']
    this.orderDetail()
  }

  clickEvent(url){
    var newurl = this.invoicePdfPath + url
    window.open(newurl, "_blank")
  }


  orderDetail(){
    let formdata;
    formdata = {"order_id": this.orderId, "sort" : this.sort , "order" : this.sortOrder} 
    this.orderService.getOrders(formdata)
    .subscribe(
      data => {
        if(data.status == 1153){
          this.alertService.error(data.response)
        }else if(data.status == 200 && data.response){
         this.orderDetails = data.response
         this.orderDetail['price_visibility'] = this.global_data['price_visibility']
         this.products = data.response.order_details
        }else{
          this.alertService.error(data.response ? data.response : 'Error')
        }
        this.componentLoaded = true
      }
    );
  }

}
